import React, { HTMLAttributes, useState, useEffect } from 'react';
import { KeyPress } from "@att-bit/duc.utils.key-press";
export type RadioGroupElementsDirection = "column" | "2-column" | "row";

export type RadioGroupProps = {
  /**  children to be RadioButton components  */
  children: React.ReactNode,
  /** sets the id for each radio button in this group by adding index to it */
  uniqueId: string,
  /** Sets the default selected RadioButton to be the one with its value to be the value of "defaultChecked" */
  //defaultValue?: string,
  /** Sets the default selected RadioButton to be the one with its value to be the value of "defaultChecked" */
  value?: string,
  /** Determines if RadioGroup should be in an error state */
  error?: boolean,
  /** Sets the erro
   * r message */
  errorMessage?: string,
  /** Sets "name" attribute of the RadioButton children */
  name: string,
  /** Sets the direction ("column" | "row" | 2-column) of display for RadioButtons */
  elementsDirection?: RadioGroupElementsDirection,
  /** Set to true if need default selection back without page refresh */
  // persistentDefaultChecked?: boolean,
  /** Sets the selected RadioButton to be the one with its value to be the value of "selected" */
  // selected?: string,
  /** Sets the title for the RadioGroup */
  title?: string,
  /** Sets the class for title of the RadioGroup */
  titleClassName?: string,
  /** Event that is triggered when the selected RadioButton changes */
  onChange?: (selected: string) => void,
};

// for memo: export const RadioGroup = React.memo(({
export const RadioGroup = ({
  children,
  uniqueId,
  /*defaultValue = "",*/
  value,
  error = false,
  errorMessage = "",
  name,
  elementsDirection = "row",
  /*persistentDefaultChecked = false,
  selected,*/
  title,
  titleClassName = "",
  onChange,
  ...props
}: RadioGroupProps & HTMLAttributes<HTMLInputElement>) => {

  // HOOKS ##############################################################

  /* stateful items */
  const [selectedVal, setSelectedVal] = useState(value ? value : "");

  /* asynchronous after render - only execute on state change for... */
  /*useEffect(() => {
    //istanbul ignore next
    if (selectedVal !== defaultValue && persistentDefaultChecked) {
      setSelectedVal(defaultValue);
    }
  }, [persistentDefaultChecked]);*/
  useEffect(() => {
    //istanbul ignore next
    if (value !== "") {
      setSelectedVal(value);
    }
  }, [value]);

  // METHODS #############################################################

  const renderChildren = () => {
    return React.Children.map(children, (child: any, idx) => {
        return React.cloneElement(child, {
            id: uniqueId + "-" + idx,
            error: error,
            name: name,
            elementsDirection: elementsDirection,
            selected: selectedVal === child.props.value,
            onChange: handleChange
        });
    });
  };
  
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedVal(event.currentTarget.value);
    //istanbul ignore next
    if (onChange) {
      onChange(event.currentTarget.value);
    }
  };

  // RENDER ##############################################################
  const titleClass = titleClassName.indexOf("type-") > -1 ? titleClassName : `type-sm ${titleClassName}`;
  return (
    <React.Fragment>
      <div className={["form-row", props.className ? props.className : ""].join(" ")}>
                <fieldset className={`${error ? "error" : ""} ${elementsDirection === "2-column" ? "grid-lg block-md block-sm col-2 col-gap24 nopad" : ""}`}>
                    {title && (
                        <legend
                            className={
                                "font-bold color-gray-800 " + titleClass
                            }
                        >
                            <span>{title}</span>
                        </legend>
                    )}
                    {errorMessage && (
                        <div
                            id={uniqueId + "-errMsg"}
                            className={"formfield-msg"}
                            role="status"
                            aria-hidden={false}
                            tabIndex={-1}
                            aria-label="Oops! There appears to be a problem, please select one of the following radio buttons"
                        >
                            {errorMessage}
                        </div>
                    )}
                    {renderChildren()}
                </fieldset>
            </div>
    </React.Fragment>
  );
}